import { useContext } from "react"
import { AppContext } from "../App"
import { MdCall, MdLogout, MdMenu, MdNotifications, MdOutlineMessage, MdOutlineNotifications } from "react-icons/md";
import { IoNotificationsOutline, IoRefreshCircleOutline } from "react-icons/io5";
import { TbMessageDots } from "react-icons/tb";
import { callApi, setCookie } from "../Helpers";
import logo from '../assets/logo.png';
import logo_icon from '../assets/logo_icon.png';
import logo_worded from '../assets/logo_worded_only.png';

export default function TopBar(props) {

  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({
      item,
    })
  }

  return (
    <div
      className="TopBar"
    >
      <div className="body">
        <div
          className="container d-flex justify-content-between"
          style={{
            height: "100%",
          }}
        >
          <div 
            className="align-self-center d-flex"
            style={{
              height: "100%",
              flexShrink: 1,

            }}
          >
            <MdMenu
              className="align-self-center mMobileOnly text-secondary"
              size={32}
              style={{
                flexShrink: 0,
                cursor: "pointer",
                marginRight: "0px"
              }}
              onClick={appContext.openSideBar}
            />

            <img
              src={logo_worded}
              style={{
                height: "60px",
                width: "auto",
                margin: "0",
                flexShrink: 0,
                cursor: "pointer",
              }}
              className="align-self-center mDesktopOnly"
              onClick={() => {
                appContext.navTo({
                  item: 'home',
                })
              }}
            />

            <img
              src={logo_icon}
              style={{
                height: "40px",
                width: "auto",
                margin: "0",
                marginLeft: "10px",
                flexShrink: 0,
                cursor: "pointer",
              }}
              className="align-self-center mMobileOnly"
              onClick={() => {
                appContext.navTo({
                  item: 'home',
                })
              }}
            />
          </div>

          <div
            className="DesktopMenu align-self-center mNoMargin mNoPadding"
            style={{
              height: "100%",
              width: "auto",
              flexShrink: 0,
            }}
          >

            <div
              className="mMenuItem"
              onClick={() => goTo("home")}
              style={{
                borderBottom: (appContext.navItem === 'home' || !appContext.navItem) ? "4px solid var(--secondaryColor)" : "none",
                transition: "all 0.4s ease-in",
              }}
            >
              Home
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("about_us")}
              style={{
                borderBottom: (appContext.navItem === 'about_us') ? "4px solid var(--secondaryColor)" : "none",
                transition: "all 0.4s ease-in",
              }}
            >
              About Us
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("services")}
              style={{
                borderBottom: (appContext.navItem === 'services') ? "4px solid var(--secondaryColor)" : "none",
                transition: "all 0.4s ease-in",
              }}
            >
              Services
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("gallery")}
              style={{
                borderBottom: (appContext.navItem === 'gallery') ? "4px solid var(--secondaryColor)" : "none",
                transition: "all 0.4s ease-in",
              }}
            >
              Gallery
            </div>

            <div
              className="mMenuItem"
              onClick={() => goTo("contact_us")}
              
            >
              <button
                className="btn font-bold btn-rounded"
                style={{
                  fontSize: "14px"
                }}
              >
                <MdCall className="text-secondary" size={32}/>
              </button>
            </div>

          </div>

          <div
            className="align-self-center mNoMargin mNoPadding mMobileOnly"
            style={{
              height: "100%",
              width: "auto",
              flexShrink: 0,
            }}
          >

            <div
              className="mMenuItem"
            >
              <button
                className="btn btn-primary font-bold btn-rounded"
                style={{
                  fontSize: "14px"
                }}
                onClick={() => goTo("contact_us")}
              >
                <MdCall className="text-light" size={32}/>
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}